import React from 'react';
import styles from "./Sidebar.module.scss";
import {connect} from "react-redux";
import {getAvailableCompanies, getCompanyFilter, getFilteredTransports} from "../../store/filterSlice";
import {
    getConfigTimezone, getStaticConfig
} from "../../store/configSlice";
import companiesIcon from '../../assets/images/static/companiesIcon.svg'
import transports from '../../assets/images/static/transports.svg'
import onlineIcon from '../../assets/images/static/onlineIcon.svg'
import traceabilityIcon from '../../assets/images/static/traceabilityIcon.svg'
import transportInGarageIcon from '../../assets/images/static/transportInGarageIcon.svg'
import transportNotInGarageIcon from '../../assets/images/static/transportNotInGarageIcon.svg'
import {getAllCompanies} from "../../store/transportSlice";

function Statics({transportData, staticConfig, availableCompanies, selectedCompanies}) {

    const {showBlock: seeBlock, showAllTransport: seeAllTransport,
        showAllCompanies: seeAllCompanies, showTransportInGarage: seeTransportInGarage
    ,showTransportNotInGarage: seeTransportNotInGarage, showTransportOnline: seeTransportOnline,
        showTraceability: setTraceability} = staticConfig

    const online = (time, atGarage) => {
        const timestamp = time * 1000;
        let timezoneUser;

        if ((new Date().getTimezoneOffset() / -60).toString().includes('-')) {
            timezoneUser = `${(new Date().getTimezoneOffset() / -60)}.0`
        } else {
            timezoneUser = `+${new Date().getTimezoneOffset() / -60}.0`;
        }
        const utc0Timestamp = timestamp - timezoneUser * 60 * 60 * 1000;

        const localTimezone = -new Date().getTimezoneOffset() / 60;
        const localTimestamp =
            utc0Timestamp + localTimezone * 60 * 60 * 1000;

        const secondGap = Math.round((Date.now() - localTimestamp) / 1000)

        const minuteGap = Math.round(secondGap / 60);

        return minuteGap <= 5 && !atGarage;
    }

    const allTransport = React.useMemo(() => {
        if (transportData?.length) {
            return transportData?.length
        }
    }, [transportData])

    const allAvailableCompanies = React.useMemo(() => {
        if (Array.isArray(selectedCompanies)) {
            return selectedCompanies?.length
        }
        if (selectedCompanies === true) {
            return availableCompanies.length
        }
    }, [selectedCompanies, availableCompanies])


    const onlineTransport = React.useMemo(() => {
        if (transportData?.length) {
            return transportData?.reduce(function(sum, current) {
                if (online(current.time, current.atGarage)) {
                    return sum + 1;
                }
                return sum
            }, 0)
        }
    }, [transportData])

    const transportInGarage = React.useMemo(() => {
        if (transportData?.length) {
            return transportData?.reduce(function(sum, current) {
                if (current.atGarage) {
                    return sum + 1;
                }
                return sum
            }, 0)
        }
    }, [transportData.length])

    const transportNotInGarage = React.useMemo(() => {
        if (transportData?.length) {
            return transportData?.reduce(function(sum, current) {
                if (!current.atGarage) {
                    return sum + 1;
                }
                return sum
            }, 0)
        }
    }, [transportData.length])


    const traceability = React.useMemo(() => {
        if (transportData?.length) {
            return ~~((onlineTransport / transportNotInGarage) * 100).toFixed(0);
        }
    }, [transportData.length, onlineTransport, transportNotInGarage])


    return (
        <>
            {seeBlock ? <div className={styles.boxStatics}>
                <div className={styles.groupTitleStatics}>
                    Статистика:
                </div>
                <div className={styles.staticsRow}>
                    {seeAllCompanies ? <div className={styles.staticsElement}>
                        <div className={styles.staticsElementLeft}>
                            <img src={companiesIcon} alt="companies"/>
                            <span>Всего организаций:</span>
                        </div>
                        <div className={styles.staticsElementRight}>{allAvailableCompanies}</div>
                    </div> : null}
                    <>
                        {seeAllTransport ?
                            <>
                                <div className={styles.staticsElementLast}>
                                    <div className={styles.staticsElementLeft}>
                                        <img src={transports} alt="transports"/>
                                        <span>Всего техники:</span>
                                    </div>
                                    <div className={styles.staticsElementRight}><span>{allTransport}</span><span>{' '}ед.</span></div>
                                </div>
                                {seeTransportInGarage ? <div className={styles.staticsElementChild}>
                                    <div className={styles.staticsElementChildLeft}>
                                        <img src={transportInGarageIcon} alt="online"/>
                                        <span>в гараже:</span>
                                    </div>
                                    <div className={styles.staticsElementChildRight}><span>{transportInGarage}</span>{' '}ед.</div>
                                </div> : null}
                                {seeTransportNotInGarage ? <div className={styles.staticsElementChild}>
                                    <div className={styles.staticsElementChildLeft}>
                                        <img src={transportNotInGarageIcon} alt="online"/>
                                        <span>на линии:</span>
                                    </div>
                                    <div className={styles.staticsElementChildRight}><span>{transportNotInGarage}</span>{' '}ед.</div>
                                </div> : null}
                                {seeTransportOnline ? <div className={styles.staticsElementChild}>
                                    <div className={styles.staticsElementChildLeft}>
                                        <img src={onlineIcon} alt="online"/>
                                        <span>из них на связи:</span>
                                    </div>
                                    <div className={styles.staticsElementChildRight}><span>{onlineTransport}</span>{' '}ед.</div>
                                </div> : null}
                                {setTraceability ? <div className={styles.staticsElementChild}>
                                    <div className={styles.staticsElementChildLeft}>
                                        <img src={traceabilityIcon} alt="online"/>
                                        <span>отслеживаемость:</span>
                                    </div>
                                    <div className={styles.staticsElementChildRight}><span>{traceability}</span>{' '}%</div>
                                </div> : null}
                            </> : null
                        }
                    </>
                </div>
            </div> : null}
        </>
    );
}

const Static = connect(
    (state) => ({
        transportData: getFilteredTransports(state),
        timezone: getConfigTimezone(state),
        companies: getAllCompanies(state),
        staticConfig: getStaticConfig(state),
        selectedCompanies: getCompanyFilter(state),
        availableCompanies: getAvailableCompanies(state),
    })
)(Statics);


Static.propTypes = {}



export { Static }
